mutation UpdatePollWeights(
  $pollId: ID!
  $tickerBlockWeights: [Float!]
) {
  poll: StreamToolsUpdatePoll(
    pollId: $pollId
    tickerBlockWeights: $tickerBlockWeights
  ) {
    pollId
    eventId
    name
    broadcasterUserIds
    question
    status
    dedupe
    youtubeVotesEnabled
    totalVotes
    closeGraceSeconds
    graceEndsAt
    youtubeCountsPurgedAt
    startedAt
    stoppedAt
    createdAt
    callToActionText
    headingTextColor
    optionsTextColor
    callToActionTextColor
    headingBackground
    optionsBackground
    callToActionBackground
    alternatingOptionBackground
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    winnerOutlineColor
    fontKey
    template
    tickerLabel
    ctaSubtext
    tickerTextSize
    tickerBlockWeights
    questionFontSize
    tickerLabelFontSize
    displayTextFontSize
    commandFontSize
    numberFontSize
    callToActionFontSize
    closedTextFontSize
    tickerHeight
    version
    options {
      optionId
      displayText
      command
      voteCount
      voteCountByPlatform { twitch youtube }
      textColor
      progressBarColor
      backgroundColor
    }
  }
}
